export default [
  {
    name: 'getCategory',
    method: 'GET',
    path: '/vue/category/category-get'
  },
  {
    name: 'getCategoryList',
    method: 'POST',
    path: '/vue/category/category-page'
  },
  {
    name: 'getCategoryProjectEnum',
    method: 'GET',
    path: '/vue/category/category-project-type'
  },
  {
    name: 'getCategoryParentIds',
    method: 'GET',
    path: '/vue/category/category-parentIds-get'
  },
  {
    name: 'saveCategory',
    method: 'POST',
    path: '/vue/category/category-save'
  },
  {
    name: 'deleteCategory',
    method: 'POST',
    path: '/vue/category/category-delete'
  },
  {
    name: 'initCategory',
    method: 'GET',
    path: '/vue/category/category-getByParentId'
  },
  {
    name: 'loadCategory',
    method: 'GET',
    path: '/vue/category/category-getByParentId'
  },
  {
    name: 'getByParentId',
    method: 'GET',
    path: '/vue/category/category-getByParentId'
  },
  {
    name: 'searchCategory',
    method: 'POST',
    path: '/vue/category/category-findList'
  },
  {
    name: 'getParentsPathById',
    method: 'GET',
    path: '/vue/category/category-getParentsPathById'
  },
  {
    name: 'getPropertiesList',
    method: 'POST',
    path: '/vue/props/get-properties-list'
  },
  {
    name: 'delProperties',
    method: 'POST',
    path: '/vue/props/properties-delete-ids'
  },
  {
    name: 'saveProperties',
    method: 'POST',
    path: '/vue/props/properties-save'
  },
  {
    name: 'getPropertiesValueList',
    method: 'POST',
    path: '/vue/props/get-propertiesvalue-list'
  },
  {
    name: 'getPropertiesValue',
    method: 'POST',
    path: '/vue/props/get-propertiesValue'
  },
  {
    name: 'delPropertiesValue',
    method: 'POST',
    path: '/vue/props/propertiesvalue-delete-ids'
  },
  {
    name: 'savePropertiesValue',
    method: 'POST',
    path: '/vue/props/save-propertiesValue'
  },
  {
    name: 'disableCategory',
    method: 'POST',
    path: '/vue/category/category-disable'
  },
  {
    name: 'enableCategory',
    method: 'POST',
    path: '/vue/category/category-enable'
  }
];
